<template>
    <div :id="this.id" class="vue-app">
        <div>
            <component
                :apiActions="apiActions"
                :configTexts="configTexts"
                :startingMode="startingMode"
                :dynamicType="dynamicType"
                :is="currentView"
            ></component>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
const widgetTypesDynamicRente = [
    "benefits",
    "benefitsNorent",
    "vaus",
    "death",
    "risiko",
    "invalidity",
];
export default {
    name: "app",
    components: {
        "simulation-einkauf": () =>
            import(
                /* webpackChunkName: "simeinkauf" */ "@/components/simulations/Einkauf.vue"
            ),
        "simulation-einkaufspotenzial": () =>
            import(
                /* webpackChunkName: "simeinkaufpot" */ "@/components/simulations/Einkaufspotenzial.vue"
            ),
        "simulation-wef": () =>
            import(
                /* webpackChunkName: "simwef" */ "@/components/simulations/Wef.vue"
            ),
        "simulation-wefPayback": () =>
            import(
                /* webpackChunkName: "simwefpayback" */ "@/components/simulations/WefPayback.vue"
            ),
        "simulation-iv": () =>
            import(
                /* webpackChunkName: "simiv" */ "@/components/simulations/Iv.vue"
            ),
        "simulation-todesfall": () =>
            import(
                /* webpackChunkName: "simtodesfall" */ "@/components/simulations/Todesfall.vue"
            ),
        "simulation-todesfall25": () =>
            import(
                /* webpackChunkName: "simtodesfall25" */ "@/components/simulations/todesfall/Todesfall25.vue"
            ),
        "simulation-beitrag": () =>
            import(
                /* webpackChunkName: "simbeitrag" */ "@/components/simulations/Beitrag.vue"
            ),
        "simulation-pension": () =>
            import(
                /* webpackChunkName: "simpension" */ "@/components/simulations/pension/Pension.vue"
            ),
        "simulation-pension2024": () =>
            import(
                /* webpackChunkName: "simpension2024" */ "@/components/simulations/pension/pension-beta/Pension2024.vue"
            ),
        "simulation-hypothekenrechner": () =>
            import(
                /* webpackChunkName: "simhypo" */ "@/components/simulations/Hypothekenrechner.vue"
            ),
        "widgets-aboutYou": () =>
            import(
                /* webpackChunkName: "widgetaboutyou" */ "@/components/widgets/AboutYou.vue"
            ),
        "widgets-aboutYouSimple": () =>
            import(
                /* webpackChunkName: "widgetaboutyou" */ "@/components/widgets/AboutYouSimple.vue"
            ),
        "widgets-dashboard": () =>
            import(
                /* webpackChunkName: "widgetdash" */ "@/components/widgets/Dashboard.vue"
            ),
        "widgets-dashboardNorent": () =>
            import(
                /* webpackChunkName: "widgetdashnr" */ "@/components/widgets/DashboardNorent.vue"
            ),
        "widgets-dashboardPension": () =>
            import(
                /* webpackChunkName: "widgetdashps" */ "@/components/widgets/DashboardPension.vue"
            ),
        "widgets-benefits": () =>
            import(
                /* webpackChunkName: "widgetbenefits" */ "@/components/widgets/Benefits.vue"
            ),
        "widgets-benefitsNorent": () =>
            import(
                /* webpackChunkName: "widgetbenefitsnr" */ "@/components/widgets/BenefitsNorent.vue"
            ),
        "widgets-divorce": () =>
            import(
                /* webpackChunkName: "widgetdivorce" */ "@/components/widgets/Divorce.vue"
            ),
        "widgets-invalidity": () =>
            import(
                /* webpackChunkName: "widgetiv" */ "@/components/widgets/Invalidity.vue"
            ),
        "widgets-retirement": () =>
            import(
                /* webpackChunkName: "widgetretirement" */ "@/components/widgets/Retirement.vue"
            ),
        "widgets-death": () =>
            import(
                /* webpackChunkName: "widgetdeath" */ "@/components/widgets/Death.vue"
            ),
        "widgets-wef": () =>
            import(
                /* webpackChunkName: "widgetwef" */ "@/components/widgets/Wef.vue"
            ),
        "widgets-wefWithdrawals": () =>
            import(
                /* webpackChunkName: "widge-wefwithdr" */ "@/components/widgets/WefWithdrawals.vue"
            ),
        "widgets-purchase": () =>
            import(
                /* webpackChunkName: "widgeteinkauf" */ "@/components/widgets/Purchase.vue"
            ),
        "widgets-einkaufspotenzial": () =>
            import(
                /* webpackChunkName: "widgeteinkaufpot" */ "@/components/widgets/Einkaufspotenzial.vue"
            ),
        "widgets-contribution": () =>
            import(
                /* webpackChunkName: "widgetcontr" */ "@/components/widgets/Contribution.vue"
            ),
        "widgets-contributionLink": () =>
            import(
                /* webpackChunkName: "widgetcontrlink" */ "@/components/widgets/ContributionLink.vue"
            ),
        "widgets-contributionexplanation": () =>
            import(
                /* webpackChunkName: "widgetcontrexplan" */ "@/components/widgets/Contributionexplanation.vue"
            ),
        "widgets-provision": () =>
            import(
                /* webpackChunkName: "widgetprovision" */ "@/components/widgets/Provision.vue"
            ),
        "widgets-provisionData": () =>
            import(
                /* webpackChunkName: "widgetprivisondata" */ "@/components/widgets/ProvisionData.vue"
            ),
        "widgets-vaus": () =>
            import(
                /* webpackChunkName: "widgetvaus" */ "@/components/widgets/Vaus.vue"
            ),
        "einkauf-list": () =>
            import(
                /* webpackChunkName: "standaloneeinkauf" */ "@/components/payments/einkauf/EinkaufList.vue"
            ),
        "scheidung-list": () =>
            import(
                /* webpackChunkName: "standaloneeinkauf" */ "@/components/payments/scheidung/ScheidungList.vue"
            ),
        "wef-list": () =>
            import(
                /* webpackChunkName: "standaloneeinkauf" */ "@/components/payments/wef/WefList.vue"
            ),
        rentenrechner: () =>
            import(
                /* webpackChunkName: "standalonerentenrechner" */ "@/components/standalone/Rentenrechner.vue"
            ),
        beitragsrechner: () =>
            import(
                /* webpackChunkName: "standalonebeitragsrechner" */ "@/components/standalone/Beitragsrechner.vue"
            ),
        "widgets-risiko": () =>
            import(
                /* webpackChunkName: "widgetrisiko" */ "@/components/widgets/Risiko.vue"
            ),
        "widgets-vollversicherung": () =>
            import(
                /* webpackChunkName: "widgetvollversicherung" */ "@/components/widgets/Vollversicherung.vue"
            ),
        "widgets-rmhModelcompare": () =>
            import(
                /* webpackChunkName: "widgetrmhmodelcompare" */ "@/components/widgets/rmh/RmhModelcompare.vue"
            ),
        "widgets-rmhDecision": () =>
            import(
                /* webpackChunkName: "widgetrmhdecision" */ "@/components/widgets/rmh/RmhDecision.vue"
            ),
        "widgets-rmhPlus": () =>
            import(
                /* webpackChunkName: "widgetrmhplus" */ "@/components/widgets/rmh/RmhPlus.vue"
            ),
    },
    props: ["id", "data"],
    data() {
        return {
            currentView: "widgets-dashboard",
            apiActions: {
                simulation: "",
                user: "",
                userValue: "",
                widgets: "",
                taxIncome: "",
                taxCapital: "",
                taxProvision: "",
                contribution: "",
                buyinUrl: "",
                divorcerepaymentUrl: "",
                wefrepaymentUrl: "",
                loggingUrl: "",
                welcomeUrl: "",
                postentriesUrl: "",
            },
            configTexts: {},
            startingMode: "static",
            dynamicType: "",
        };
    },
    methods: {
        ...mapActions(["initializeApiActions"]),
    },
    created() {
        //URL for api depending on environment
        let baseUrl = window.location.origin;
        //Get Actions from typo3 template
        this.apiActions.simulation = baseUrl + this.data.simulationurl;
        this.apiActions.user = baseUrl + this.data.userurl;
        this.apiActions.userValue = baseUrl + this.data.uservalueurl;
        this.apiActions.widgets = baseUrl + this.data.widgeturl;
        this.apiActions.taxIncome = baseUrl + this.data.incometaxurl;
        this.apiActions.taxCapital = baseUrl + this.data.capitaltaxurl;
        this.apiActions.taxProvision =
            baseUrl + this.data.provisionalanalysisurl;
        this.apiActions.contribution = baseUrl + this.data.contributionlevelurl;
        this.apiActions.buyinUrl = baseUrl + this.data.buyinurl;
        this.apiActions.divorcerepaymentUrl =
            baseUrl + this.data.divorcerepaymenturl;
        this.apiActions.wefrepaymentUrl = baseUrl + this.data.wefrepaymenturl;

        // These urls are not set by all plugin types
        if (this.data.loggingurl) {
            this.apiActions.loggingUrl = baseUrl + this.data.loggingurl;
        }
        if (this.data.welcomefinishedurl) {
            this.apiActions.welcomeUrl = baseUrl + this.data.welcomefinishedurl;
        }
        this.apiActions.postentriesUrl = baseUrl + this.data.postentriesurl;

        this.initializeApiActions(this.apiActions);

        //Get view to start from typo3
        switch (this.data.mode) {
            case "list":
                break;
            case "single":
                this.currentView = "simulation-" + this.data.type;
                break;
            case "einkauf":
                this.currentView = "einkauf-list";
                break;
            case "scheidung":
                this.currentView = "scheidung-list";
                break;
            case "wef":
                this.currentView = "wef-list";
                break;
            case "rentenrechner":
                this.currentView = "rentenrechner";
                break;
            case "beitragsrechner":
                this.currentView = "beitragsrechner";
                break;
            case "widget": {
                let widgetType = this.data.type;
                if (
                    widgetType == "contribution" ||
                    widgetType == "contributionexplanation"
                ) {
                    this.dynamicType = "beitrag";
                    this.startingMode = "dynamic";
                } else if (widgetType == "aboutYou") {
                    this.dynamicType = "aboutyou";
                    this.startingMode = "static";
                } else if (widgetType == "aboutYouSimple") {
                    this.dynamicType = "aboutYouSimple";
                    this.startingMode = "static";
                } else if (widgetType == "vaus") {
                    this.dynamicType = "vaus";
                    this.startingMode = "dynamic";
                } else if (widgetTypesDynamicRente.includes(widgetType)) {
                    this.dynamicType = "leistungen";
                    this.startingMode = "dynamic";
                }
                this.currentView = "widgets-" + widgetType;
                break;
            }
            default:
                break;
        }

        for (let d in this.data) {
            if (d.startsWith("url")) {
                let newd = d.substr(3);
                this.apiActions[`url${newd}`] = this.data[d];
            }
        }

        for (let d in this.data) {
            if (d.startsWith("texts")) {
                let newd = d.substr(5);
                this.configTexts[newd] = this.data[d];
            }
        }
    },
};
</script>
<style lang="scss">
@import "scss/custom";
</style>
